function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrecauciones3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    width: 140,
    height: 130,
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(83,170,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M194-194v-572 471-81 182Zm32 22q-22.77 0-38.39-15.61Q172-203.23 172-226v-508q0-22.78 15.61-38.39Q203.23-788 226-788h508q22.78 0 38.39 15.61T788-734v339h-22v-339q0-12-10-22t-22-10H226q-12 0-22 10t-10 22v508q0 12 10 22t22 10h264v22H226Zm465 40-96-95 16-17 80 81 162-161 16 15-178 177ZM320-455q11 0 18-7t7-18q0-11-7-18t-18-7q-11 0-18 7t-7 18q0 11 7 18t18 7Zm0-149q11 0 18-7t7-18q0-11-7-18t-18-7q-11 0-18 7t-7 18q0 11 7 18t18 7Zm128 135h209v-22H448v22Zm0-149h209v-22H448v22Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrecauciones3);
export default __webpack_public_path__ + "static/media/precauciones3.0d2ba1502651357350e85c4c018b661f.svg";
export { ForwardRef as ReactComponent };